// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2hSyN","overflowing":"ReadFullNote_overflowing__11fib"};